module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1g20g"))).then(() => module.bundle.root('dsisd'));